import { render, staticRenderFns } from "./AddonDomainsTable.vue?vue&type=template&id=4f57f353&"
import script from "./AddonDomainsTable.vue?vue&type=script&lang=js&"
export * from "./AddonDomainsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f57f353')) {
      api.createRecord('4f57f353', component.options)
    } else {
      api.reload('4f57f353', component.options)
    }
    module.hot.accept("./AddonDomainsTable.vue?vue&type=template&id=4f57f353&", function () {
      api.rerender('4f57f353', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/AddonDomains/AddonDomainsTable.vue"
export default component.exports